import {LessonFacetItem} from "@modules/activities/core/lesson-facets/models";

export enum ActivitySearchEngineStep {
    CONCEPTS = 'concepts',
    EDUCATIONAL_LEVELS = 'educational_levels',
    EDUCATIONAL_LEVELS_FROM_EXCLUSIVE_LIST = 'educational_levels_from_exclusive_list',
    CHAPTERS = 'chapters',
    LESSONS = 'lessons',
}

export interface ActivitySearchEngineConfig {
    flattenSubLesson?: boolean;
    steps?: ActivitySearchEngineStep[];
    selectedEducationalLevels?: LessonFacetItem[];
}

export const ALLOWED_ACTIVITY_SEARCH_STEPS: ActivitySearchEngineStep[] = [
    ActivitySearchEngineStep.CONCEPTS,
    ActivitySearchEngineStep.EDUCATIONAL_LEVELS,
    ActivitySearchEngineStep.EDUCATIONAL_LEVELS_FROM_EXCLUSIVE_LIST,
    ActivitySearchEngineStep.CHAPTERS,
    ActivitySearchEngineStep.LESSONS,
];

export const DEFAULT_ACTIVITY_SEARCH_STEPS: ActivitySearchEngineStep[] = [
    ActivitySearchEngineStep.CONCEPTS,
    ActivitySearchEngineStep.EDUCATIONAL_LEVELS_FROM_EXCLUSIVE_LIST,
    ActivitySearchEngineStep.CHAPTERS,
    ActivitySearchEngineStep.LESSONS,
];
